// extracted by css-extract-rspack-plugin
export default {"menuButton":"ActivityOverflowMenu-module__menuButton__telV9"};